var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_12242)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E4E7EB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_358_12242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 5C13.8244 5 11.6977 5.64514 9.88873 6.85383C8.07979 8.06253 6.66989 9.78049 5.83733 11.7905C5.00477 13.8005 4.78693 16.0122 5.21137 18.146C5.6358 20.2798 6.68345 22.2398 8.22183 23.7782C9.76021 25.3166 11.7202 26.3642 13.854 26.7886C15.9878 27.2131 18.1995 26.9952 20.2095 26.1627C22.2195 25.3301 23.9375 23.9202 25.1462 22.1113C26.3549 20.3023 27 18.1756 27 16C27 13.0826 25.8411 10.2847 23.7782 8.22183C21.7153 6.15893 18.9174 5 16 5ZM23.1844 12.3081L14.1506 21.335L8.81563 16C8.63329 15.8177 8.53086 15.5704 8.53086 15.3125C8.53086 15.0546 8.63329 14.8073 8.81563 14.625C8.99797 14.4427 9.24527 14.3402 9.50313 14.3402C9.76099 14.3402 10.0083 14.4427 10.1906 14.625L14.1644 18.5988L21.8231 10.9469C21.9134 10.8566 22.0206 10.785 22.1386 10.7361C22.2565 10.6873 22.3829 10.6621 22.5106 10.6621C22.6383 10.6621 22.7647 10.6873 22.8827 10.7361C23.0007 10.785 23.1078 10.8566 23.1981 10.9469C23.2884 11.0372 23.36 11.1443 23.4089 11.2623C23.4578 11.3803 23.4829 11.5067 23.4829 11.6344C23.4829 11.7621 23.4578 11.8885 23.4089 12.0064C23.36 12.1244 23.2884 12.2316 23.1981 12.3219L23.1844 12.3081Z",
    fill: "#35A936"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_12242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_358_12242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/confirmed.96ed9eb91cc0dcbd97607b547de0c93e.svg";
export { ForwardRef as ReactComponent };